import VueExcelXlsx from "./VueExcelXlsx.vue";

export default {
    install(Vue, options) {
        Vue.component("vue-excel-xlsx", VueExcelXlsx);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-excel-xlsx/index.js
// module id = p39F
// module chunks = 5